import React from 'react';
import { useNavigate } from 'react-router-dom';
import css from './PaymentTab.module.scss';
import { useAppSelector, useAppDispatch } from '../../../../hooks/redux';
import { setFilters } from '../../../../store/reducers/filtersSlice';
import { parseDate } from '../../../../utils/common';
import { EDirection } from '../../../../store/reducers/enumTypes';

type TPaymentTab = {
  title: string;
  count: number;
  direction: EDirection;
};

export const PaymentTab = ({ title, count, direction }: TPaymentTab) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { filters } = useAppSelector((state) => state.filtersReducer);
  const dateFrom = parseDate(new Date(), 'yyyy-MM-dd');

  return (
    <div
      onClick={() => {
        dispatch(
          setFilters({
            ...filters,
            dateFrom,
            direction,
          })
        );
        navigate('/payments');
      }}
      className={css.root}
    >
      <div className={css.title}>{title}</div>
      <div className={css.count}>{count}</div>
    </div>
  );
};
